import './index.css';
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { ConfirmModal } from './ui-components/ConfirmationModal';
import CustomLoadingScreen from 'ui-components/CustomLoadingScreen';
import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <>
      <Suspense fallback={<CustomLoadingScreen />}>
        <AppRouter />
        <ConfirmModal />
      </Suspense>
    </>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
